import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../../components/Typography'
import cn from 'classnames'
import { VendorsDragList } from '../VendorsDragList/VendorsDragList'
import IconNameItem from 'components/IconNameItem/IconNameItem'
import { routes } from 'router'
import { Link } from 'components/Link'
import { getSurveyProxySubmittedByLabel } from '../../getSurveyProxySubmittedByLabel'
import { TProxyVoter } from '../../types'
import { SurveyPreviewCategoryProps } from './types'

export const SurveyPreviewCategory = ({
  categoryName,
  activeIdx,
  pagesCount,
  vendors,
  isVotingDisabled,
  setActiveSelectionList,
  isSurveySubmitted,
  rfpCreatorUuid,
  proxyVoter: proxyVoterProp
}: SurveyPreviewCategoryProps) => {
  const proxyVoter =
    proxyVoterProp ??
    (vendors?.[0] as { proxy_voter?: TProxyVoter | null } | undefined)
      ?.proxy_voter

  return (
    <>
      <div className="flex column survey-category-wrapper p-16 mb-8 mt-32">
        <div className="row full-width space-between">
          <div>
            <Typography.Label className="mb-4 label-color">
              Contract category
            </Typography.Label>
            <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.BOLD}>
              {categoryName}
            </Typography.Body1>
          </div>
          <div>
            <Typography.Body2 className="label-color">
              {`${activeIdx + 1}/${pagesCount}`}
            </Typography.Body2>
          </div>
        </div>
        {!!proxyVoter && (
          <>
            <div className="separator" />
            <div className="row align-center gap-8 submitted-by">
              <Typography.Body2>
                {getSurveyProxySubmittedByLabel(proxyVoter, rfpCreatorUuid)}
              </Typography.Body2>
              <Link
                className="row gap-4 align-center"
                to={`${routes.createUserProfile}/${proxyVoter.uuid}?fromCommunity=true`}
              >
                <IconNameItem
                  firstName={proxyVoter.first_name}
                  lastName={proxyVoter.last_name}
                  src={null}
                  roleName={''}
                />
              </Link>
            </div>
          </>
        )}
      </div>
      <div className={cn({ 'survey-preview__ratings': !isSurveySubmitted })}>
        <VendorsDragList
          vendorsList={vendors}
          setVendorsList={setActiveSelectionList}
          isDisabled={isVotingDisabled}
        />
      </div>
    </>
  )
}
